<h2 mat-dialog-title>DETALLE DE RECAUDO</h2>
<mat-dialog-content class="mat-typography">
  <div class="contenedor-form" *ngIf="loadingData">
    <mat-spinner
      [diameter]="100"
      style="margin:0 auto; top:15px;"
    ></mat-spinner>
  </div>

  <mat-expansion-panel [hidden]="loadingData" expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h4 class="titulo-solicitud">INFORMACIÓN CLIENTE</h4>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="row" [hidden]="loadingData">
        <div class="col s12 m12 l12">
            <div class="table-wrapper">
                <table class="fl-table">
                    <thead>
                    <tr>
                        <th>NIT</th>
                        <th>Cliente</th>
                        <th>Ciudad</th>
                        <th>Direccion</th>
                        <th>Telefono</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr >
                        <td>{{dataCliente.codigo}}</td>
                        <td>{{dataCliente.cliente}}</td>
                        <td>ARMENIA</td>
                        <td>{{dataCliente.direccion}}</td>
                        <td>{{dataCliente.telefono}}</td>
                    </tr>
                    <tbody>
                </table>
            </div>
        </div>
    </div>
  </mat-expansion-panel>

  <br />

  <div class="row">
    <div class="col s12 m12 l12">
      <p><span style="font-weight: bold;" >OBSERVACIONES:</span> {{dataCliente.observaciones}}</p>
    </div>
  </div>


  <div class="row" [hidden]="loadingData">
    <div class="col s12 m12 l12">
      <table
        [hidden]="!haveData"
        datatable
        [dtTrigger]="dtTrigger"
        class="display"
        style="width:100%; font-size: 10px;"
      >
        <thead>
          <tr>
            <th>Item</th>
            <th>Nro Recaudo</th>
            <th>Nro Detalle Recaudo</th>
            <th>Nro Documento</th>
            <th>Nro Referencia</th>
            <th>Nro Factura</th>
            <th>Tipo Documento</th>
            <th>Valor Documento</th>
            <th>Saldo Antes Abono</th>
            <th>Nro Documento Recaudo</th>
            <th>Metodo Pago de Abono</th>
            <th>Abono</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of detallePedido; let i = index">
            <td style="text-align: center;">{{ i + 1 }}</td>
            <td>{{ item.idExRecaudo }}</td>
            <td>{{ item.idExRecaudo_Documento }}</td>
            <td>{{ item.nroDocumento }}</td>
            <td>{{ item.referencia }}</td>
            <td>{{ item.nroFactura }}</td>
            <td>{{ item.tipoDocumento }}</td>
            <td>{{ item.monto | currency: "$":"symbol":"1.0-0" }}</td>
            <td>{{ item.saldo | currency: "$":"symbol":"1.0-0" }}</td>
            <td>{{ item.nroDocumentoRecaudo }}</td>
            <td>{{ item.descripcionRCTM }}</td>
            <td>{{ item.montoRCMP | currency: "$":"symbol":"1.0-0" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col s12 m12 l12">
      <mat-card class="example-card">
        <mat-card-header>
          <mat-card-title>Ubicación</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div #mapContainer id="map"></div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <div >
    <div style="float: left;">
      <p style="color: green; font-weight: bold;">TOTAL: </p>
    </div>
    <div style="float: left; margin-left: 20px;">
      <p style="color: gray; font-weight: bold;">{{totalPedido | currency: "$":"symbol":"1.0-0" }}</p>
    </div>
  </div>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="dataModified"
    cdkFocusInitial
    style="float: left; margin-left: 80%;"
  >
    Cerrar
  </button>
</mat-dialog-actions>
